import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.clients.views.FranchiseeClientListTable.';
  public static readonly client = `${Id.prefix}client`;
  public static readonly primaryContact = `${Id.prefix}primaryContact`;
  public static readonly contactEmail = `${Id.prefix}contactEmail`;
  public static readonly address = `${Id.prefix}address`;
  public static readonly paymentProfile = `${Id.prefix}paymentProfile`;
  public static readonly termsConditions = `${Id.prefix}termsConditions`;
}

export class LangFranchiseeClientListTable {
  private constructor() {}
  public static client(): string {
    return interpolate(Id.client);
  }
  public static primaryContact(): string {
    return interpolate(Id.primaryContact);
  }
  public static contactEmail(): string {
    return interpolate(Id.contactEmail);
  }
  public static address(): string {
    return interpolate(Id.address);
  }
  public static paymentProfile(): string {
    return interpolate(Id.paymentProfile);
  }
  public static termsConditions(): string {
    return interpolate(Id.termsConditions);
  }
}

export class FranchiseeClientListTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.client, "{{glossary 'client'}}", 'Column header for client name');
    register.add(Id.primaryContact, "Primary {{glossary 'contact'}}", 'Column header for primary contact');
    register.add(Id.contactEmail, "{{glossary 'contact'}} Email", 'Column header for contact email');
    register.add(Id.address, 'Address', 'Column header for address');
    register.add(Id.paymentProfile, "{{glossary 'payment-profile'}}", 'Column header for payment profile');
    register.add(Id.termsConditions, "{{glossary 'terms-conditions'}}", 'Column header for terms and conditions');
  }
}
